export default __webpack_public_path__ + "static/media/Junit-selenium-docker.6c7e37cf.jpg";